import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { Itens } from '../../models/itens.model';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-itens-list',
  templateUrl: './itens-list.component.html',
  styleUrls: ['./itens-list.component.scss','../itens-edit/itens-edit.component.scss']
})
export class ItensListComponent extends BaseFormComponent<Itens> implements OnInit {
  @Input() form:FormGroup;
  @Input() itensData:Itens;
  @Output() closeModal = new EventEmitter<void>;
  constructor(
    public activatedRoute: ActivatedRoute
  ) { 
    super(activatedRoute);
  }

  ngOnInit() {
  }
  onCloseModal(){
    this.closeModal.emit();
  }
  getFormArray(fields:string[], ids:number[] = null): FormArray {
    var item = null;
    fields.forEach((f,i)=>{
      if(!item){
        item = this.form.get(f) as FormArray;
      }
      else{
        item = item.controls[ids[i-1]]?.get(f) as FormArray;
      }
    })
    console.log(item)
    return item;
  }
  hasAnyChecked(item, key: string){
    return item.getRawValue()[key].some(it => it.checkeds === true);
  }
  cc(i){
    console.log(i)
  }
}
